import { render, staticRenderFns } from "./KlarnaInstalmentsPaymentMethod.vue?vue&type=template&id=73758950&scoped=true"
import script from "./KlarnaInstalmentsPaymentMethod.vue?vue&type=script&lang=js"
export * from "./KlarnaInstalmentsPaymentMethod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73758950",
  null
  
)

export default component.exports